import { InjectionToken } from '@angular/core';
import { ProviderContactChangeService } from '../services/provider-contact-change/provider-contact-change.service';

export const PROVIDER_CONTACT_CHANGE_SERVICE =
  new InjectionToken<ProviderContactChangeService>(
    'PROVIDER_CONTACT_CHANGE_SERVICE'
  );
